import { render, staticRenderFns } from "./AdminContactTypeForm.vue?vue&type=template&id=43a096b0"
import script from "./AdminContactTypeForm.vue?vue&type=script&lang=ts"
export * from "./AdminContactTypeForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports